<div class="data-display-wrapper">
  @if (title()) {
    <div class="data-display-header">
      <div class="data-display-header__content">
        @if (icon()) {
          <span class="data-display-header__icon material-icons">{{ icon() }}</span>
        }
        <h3 class="data-display-header__title">{{ title() }}</h3>
      </div>
    </div>
  }

  <div class="data-display-body">
    @if (data().length > 0) {
      <table class="data-display-table">
        <tbody>
          @for (item of data(); track item.label; let last = $last) {
            <tr class="data-display-row" [class.data-display-row--last]="last">
              <td class="data-display-cell data-display-cell--key">{{ item.label }}</td>
              <td class="data-display-cell data-display-cell--value">
                @if (item.template) {
                  <ng-container [ngTemplateOutlet]="item.template"></ng-container>
                } @else {
                  <div class="data-display-values">
                    @for (value of item.value; track value) {
                      <div class="data-display-value">{{ value }}</div>
                    }
                  </div>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    } @else {
      <div class="data-display-empty">Keine Daten vorhanden</div>
    }
  </div>
</div>
